export const BtPayErrorMessageKeys = {
  '-1': 'bt_pay_error_-1',
  '-100': 'bt_pay_error_-100',
  '-102': 'bt_pay_error_-102',
  '-2000': 'bt_pay_error_-2000',
  '-2001': 'bt_pay_error_-2001',
  '-2002': 'bt_pay_error_-2002',
  '-2003': 'bt_pay_error_-2003',
  '-2005': 'bt_pay_error_-2005',
  '-2006': 'bt_pay_error_-2006',
  '-2007': 'bt_pay_error_-2007',
  '-2008': 'bt_pay_error_-2008',
  '-2010': 'bt_pay_error_-2010',
  '-2011': 'bt_pay_error_-2011',
  '-2012': 'bt_pay_error_-2012',
  '-2013': 'bt_pay_error_-2013',
  '-2015': 'bt_pay_error_-2015',
  '-2016': 'bt_pay_error_-2016',
  '-2017': 'bt_pay_error_-2017',
  '-2018': 'bt_pay_error_-2018',
  '-2019': 'bt_pay_error_-2019',
  '-2020': 'bt_pay_error_-2020',
  '-2101': 'bt_pay_error_-2101',
  '-2102': 'bt_pay_error_-2102',
  '-3003': 'bt_pay_error_-3003',
  '-9000': 'bt_pay_error_-9000',
  '-20010': 'bt_pay_error_-20010',
  0: 'bt_pay_error_0',
  1: 'bt_pay_error_1',
  5: 'bt_pay_error_5',
  100: 'bt_pay_error_100',
  101: 'bt_pay_error_101',
  103: 'bt_pay_error_103',
  104: 'bt_pay_error_104',
  106: 'bt_pay_error_106',
  107: 'bt_pay_error_107',
  109: 'bt_pay_error_109',
  110: 'bt_pay_error_110',
  111: 'bt_pay_error_111',
  116: 'bt_pay_error_116',
  117: 'bt_pay_error_117',
  119: 'bt_pay_error_119',
  120: 'bt_pay_error_120',
  121: 'bt_pay_error_121',
  123: 'bt_pay_error_123',
  124: 'bt_pay_error_124',
  125: 'bt_pay_error_125',
  208: 'bt_pay_error_208',
  209: 'bt_pay_error_209',
  320: 'bt_pay_error_320',
  400: 'bt_pay_error_400',
  801: 'bt_pay_error_801',
  803: 'bt_pay_error_803',
  804: 'bt_pay_error_804',
  805: 'bt_pay_error_805',
  861: 'bt_pay_error_861',
  871: 'bt_pay_error_871',
  902: 'bt_pay_error_902',
  903: 'bt_pay_error_903',
  904: 'bt_pay_error_904',
  905: 'bt_pay_error_905',
  906: 'bt_pay_error_906',
  907: 'bt_pay_error_907',
  909: 'bt_pay_error_909',
  910: 'bt_pay_error_910',
  913: 'bt_pay_error_913',
  914: 'bt_pay_error_914',
  915: 'bt_pay_error_915',
  917: 'bt_pay_error_917',
  952: 'bt_pay_error_952',
  998: 'bt_pay_error_998',
  999: 'bt_pay_error_999',
  1001: 'bt_pay_error_1001',
  1004: 'bt_pay_error_1004',
  1005: 'bt_pay_error_1005',
  2001: 'bt_pay_error_2001',
  2002: 'bt_pay_error_2002',
  2003: 'bt_pay_error_2003',
  2004: 'bt_pay_error_2004',
  2005: 'bt_pay_error_2005',
  2006: 'bt_pay_error_2006',
  2007: 'bt_pay_error_2007',
  2008: 'bt_pay_error_2008',
  2009: 'bt_pay_error_2009',
  2014: 'bt_pay_error_2014',
  2015: 'bt_pay_error_2015',
  9001: 'bt_pay_error_9001',
  71015: 'bt_pay_error_71015',
  151017: 'bt_pay_error_151017',
  151018: 'bt_pay_error_151018',
  151019: 'bt_pay_error_151019',
  341014: 'bt_pay_error_341014',
  341016: 'bt_pay_error_341016',
  341017: 'bt_pay_error_341017',
  341018: 'bt_pay_error_341018',
  341019: 'bt_pay_error_341019',
  341020: 'bt_pay_error_341020',
};

export const getBtPayErrorMessageKey = (code) => {
  if (code === null || code === undefined || code === '') return '-';
  return BtPayErrorMessageKeys[String(code)] || 'bt_pay_error_default';
};
